/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetExternalRestaurantHomeResult } from '../../models/get-external-restaurant-home-result';

export interface GetByRestaurantidHomeRedirection$Params {
  RestaurantId: number;
  Table?: string;
}

export function getByRestaurantidHomeRedirection(
  http: HttpClient,
  rootUrl: string,
  params: GetByRestaurantidHomeRedirection$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetExternalRestaurantHomeResult>> {
  const rb = new RequestBuilder(rootUrl, getByRestaurantidHomeRedirection.PATH, 'get');
  if (params) {
    rb.path('RestaurantId', params.RestaurantId, {});
    rb.query('Table', params.Table, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetExternalRestaurantHomeResult>;
    }),
  );
}

getByRestaurantidHomeRedirection.PATH = '/Restaurants/{RestaurantId}/home-redirection';
